import { routes } from '@aline/routes';

export enum LeftNavSection {
  ADMIN = 'Admin',
  AI_CHAT = 'AI Chat',
  COMMUNITY = 'Community',
  DASHBOARD = 'Dashboard',
  GET_STARTED = 'Get Started',
  IDENTIFIERS = 'Identifiers',
  PARTIES = 'Parties',
  PLAYBOOKS = 'Playbooks',
  REMINDERS = 'Reminders',
  REPORTS = 'Reports',
  REPOSITORY = 'Documents',
  TEMPLATES = 'Templates',
  WORKFLOWS = 'Workflows',
}

export type AppSection = LeftNavSection;

export function getRouteForAppSection(section: AppSection) {
  switch (section) {
    case LeftNavSection.ADMIN:
      return routes.AdminOrgIndex;
    case LeftNavSection.AI_CHAT:
      return routes.ChatIndex;
    case LeftNavSection.DASHBOARD:
      return routes.DashboardIndex;
    case LeftNavSection.IDENTIFIERS:
      return routes.IdentifierIndex;
    case LeftNavSection.GET_STARTED:
      return routes.GetStarted;
    case LeftNavSection.PARTIES:
      return routes.PartyIndex;
    case LeftNavSection.PLAYBOOKS:
      return routes.PlaybooksIndex;
    case LeftNavSection.REMINDERS:
      return routes.RemindersIndex;
    case LeftNavSection.REPORTS:
      return routes.ReportIndex;
    case LeftNavSection.REPOSITORY:
      return routes.RepositoryIndex;
    case LeftNavSection.WORKFLOWS:
      return routes.WorkflowList;
    case LeftNavSection.TEMPLATES:
      return routes.TemplatePublished;
    case LeftNavSection.COMMUNITY:
      return routes.CommunityDocumentIndex;
  }
}

export const sectionsInOrder: LeftNavSection[] = [
  LeftNavSection.AI_CHAT,
  LeftNavSection.DASHBOARD,
  LeftNavSection.WORKFLOWS,
  LeftNavSection.TEMPLATES,
  LeftNavSection.REPOSITORY,
  LeftNavSection.PARTIES,
  LeftNavSection.REPORTS,
  LeftNavSection.PLAYBOOKS,
  LeftNavSection.REMINDERS,
];
